<template>
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M219.15 229.41C222.27 226.29 222.27 221.22 219.15 218.1C216.03 214.98 210.96 214.98 207.84 218.1C205.25
      220.69 201.8 222.12 198.13 222.12C194.46 222.12 191.01 220.69 188.42 218.1C185.3 214.98 180.23 214.98 177.11
      218.1C173.99 221.22 173.99 226.29 177.11 229.41C182.73 235.03 190.19 238.12 198.14 238.12C206.09 238.12 213.53
      235.03 219.15 229.41Z"
      fill="currentColor"
    />
    <path
      d="M335.62 159.59C339.85 160.87 344.31 158.48 345.6 154.25L354.64 124.4H392.22L401.26 154.25C404.18 164.27
      419.71 159.47 416.57 149.61L405.8 114.05C405.8 114.03 405.79 114.01 405.78 113.99L381.08 32.39C379.09 24.96
      367.75 24.96 365.77 32.39L341.07 113.99C341.06 114.01 341.06 114.03 341.05 114.05L330.28 149.61C329
      153.84 331.39 158.3 335.62 159.59ZM373.43 62.33L387.38 108.4H359.49L373.43 62.33Z"
      fill="currentColor"
    />
    <path
      d="M502 68.68C497.58 68.68 494 72.26 494 76.68V82.73C486.5 76.6 476.93 72.91 466.52 72.91C442.54 72.91 423.04
      92.42 423.04 116.39C423.04 140.36 442.55 159.87 466.52 159.87C476.94 159.87 486.51 156.19 494 150.05V151.92C494
      156.34 497.58 159.92 502 159.92C506.42 159.92 510 156.34 510 151.92V76.67C510 72.26 506.42 68.68 502 68.68ZM466.52
      143.88C451.37 143.88 439.04 131.55 439.04 116.4C439.04 101.25 451.37 88.92 466.52 88.92C481.67
      88.92 494 101.25 494
      116.4C494 131.55 481.67 143.88 466.52 143.88Z"
      fill="currentColor"
    />
    <path
      d="M267.68 278.04C260.1 275.02 252.33 271.87 244.54 268.64C243.33 268.14 242.03 267.06 242.03 265.55V258.91C263.34
      246.54 279 225.47 284.09 200.59C301.71 197.62 315.17 182.26 315.17 163.82C315.17 155.02 312.14 146.7 306.59
      140.02V78.62C306.59 36.52 272.34 2.27 230.24 2.27H172.21C145.09 2.27 122.61 22.5 119.07 48.67C102.31 52.15 89.67
      66.53 89.67 84.81V140.02C84.11 146.7 81.09 155.03 81.09 163.82C81.09 182.27 94.56 197.62 112.17 200.59C117.26
      225.47 132.92 246.55 154.23 258.92V265.56C154.23 267.07 152.93 268.14 151.72 268.65C137.06 274.71 121.77 280.15
      108.28 284.95C91.76 290.83 77.5 295.9 67.11 300.99C46.37 311.16 29.69 347.34 16.1 411.6C6.42 457.35 2.08 501.05
      2.04 501.49C1.61 505.89 4.82 509.8 9.22 510.23C9.49 510.25 9.75 510.27 10.01 510.27C14.08
      510.27 17.56 507.18 17.96
      503.05C18 502.62 22.28 459.68 31.78 414.78C47.95 338.42 65.27 319.71 74.16 315.35C83.73 310.66 97.59 305.73 113.65
      300.02C117.42 298.68 121.34 297.28 125.34 295.84L147.85 334.83C150.04 338.82 155.67 340.08 159.35 337.4L190.13
      315.99V502.27C189.98 512.65 206.28 512.65 206.13 502.27V315.99L236.91 337.4C240.6 340.08 246.21 338.82 248.41
      334.83L270.59 296.41C291.32 304.55 310.08 311.49 323.12 315.77C325.39 316.52 334.54 321.46 356.66 353.57C365.35
      366.18 372.95 378.54 376.75 384.87L370.85 393.39C368.33 397.02 369.24 402 372.87 404.52C374.26 405.48 375.85
      405.94 377.42 405.94C379.96 405.94 382.45 404.74 384 402.49L422.82 346.44C427.62 356.5 434.03 361.71 452.32
      361.71C454.61 361.71 456.75 361.57 458.77 361.31C447.1 394.52 425.22 424 407.02 448.5C402.58 454.48 398.38 460.12
      394.57 465.5C387.58 475.36 378.68 480.47 368.12 480.68C351.84 481.01 333.02 469.67 317.62
      450.28L306.44 393.2C305.59
      388.86 301.39 386.04 297.05 386.89C292.71 387.74 289.89 391.94 290.74 396.28L311.81 503.81C313.7 514.07 329.65
      510.86 327.51 500.73L323.19 478.66C337.42 490.21 352.95 496.68 367.48 496.68C367.8 496.68 368.12 496.68 368.44
      496.67C384.13 496.36 397.68 488.78 407.63 474.74C411.34 469.51 415.48 463.93 419.86 458.03C442.64 427.37 470.95
      389.25 480.1 344.21C482.61 337.32 483.75 328.2 483.75 316.51C483.75 299.88 483.32 288.41 477.62 280.84C472.74
      274.35 465.34 272.26 456.61 271.61V185.45C456.61 181.03 453.03 177.45 448.61 177.45C444.19 177.45 440.61 181.03
      440.61 185.45V271.83C432.29 273.24 425.48 277.56 420.68 284.54C412.02 297.15 412.07 315.17 415.91 328.33L386.73
      370.46C382.51 363.62 376.56 354.24 369.9 344.56C345.75 309.5 334.5 302.66 328.13 300.56C314.55 296.09 294.56
      288.67 272.59 279.98L267.69 278.03L267.68 278.04ZM285.87 183.57V144.07C288.48 145.13 290.88 146.71 292.93
      148.76C296.95 152.78 299.17 158.13 299.17 163.82C299.17 172.74 293.66 180.4 285.87 183.57ZM134.58
      82.1V55.89C134.58
      35.11 151.43 18.26 172.21 18.26H230.24C263.57 18.26 290.59 45.28 290.59 78.61V128.73C286.57 127.27 282.28 126.51
      277.87 126.51C207.15 126.51 178.44 116.49 167.58 110.49C163.45 108.21 159.07 106.41 154.57 104.99C150.94 103.84
      146.57 101.72 142.65 97.79C136.62 91.72 135.04 84.74 134.58 82.09V82.1ZM118.58 65.49V82.1C118.58 98.41 129.44
      112.22 144.3 116.71C141.22 121.31 134.23 126.52 118.39 126.52C113.98 126.52 109.69 127.28
      105.67 128.74V84.81C105.67
      76.11 111.01 68.64 118.58 65.49ZM110.39 183.57C102.6 180.4 97.09 172.75 97.09 163.83C97.09
      158.14 99.31 152.79 103.33
      148.77C105.38 146.72 107.78 145.13 110.39 144.08V183.58V183.57ZM126.39 182.98V142.12C144.17
      140.25 153.92 132.17 158.73
      123.9C172.69 132 203.29 141.76 269.87 142.48V182.98C269.87 222.54 237.69 254.72 198.13 254.72C158.57 254.72 126.39
      222.54 126.39 182.98ZM198.13 270.71C207.89 270.71 217.28 269.11 226.05 266.15C226.2 270.76 228.06 275.08 231.18
      278.43C227.13 284.11 217.78 292.67 198.13 292.67C178.48 292.67 169.12 284.12 165.08 278.43C168.2 275.08 170.06
      270.76 170.21 266.15C178.98 269.1 188.37 270.7 198.13 270.7V270.71ZM157.35 319.29L140.57
      290.23C144.04 288.92 147.53
      287.57 151.02 286.18C155.11 292.5 162.97 301.07 177.04 305.59L157.35 319.29ZM238.9 319.29L219.21
      305.59C233.25 301.08
      241.11 292.53 245.2 286.22C248.67 287.64 252.13 289.04 255.56 290.42L238.9 319.28V319.29ZM439.72
      343.43C437.82 341.77
      436.29 337.63 434.17 331.92C433.57 330.31 432.93 328.58 432.22 326.73C428.49 317.05 428.09
      302.01 433.86 293.61C436.76
      289.38 441 287.33 446.8 287.33C457.92 287.33 463.15 288.24 464.82 290.47C467.51 294.05 467.73
      305.3 467.73 316.53C467.73
      326.63 466.82 334.09 465.03 338.83C465.02 338.88 465 338.94 464.96 338.99C464.41 340.4 463.79
      341.57 463.08 342.47C461.51
      344.48 459.16 345.72 452.3 345.72C443.35 345.72 440.82 344.42 439.7 343.44L439.72 343.43Z"
      fill="currentColor"
    />
    <path
      d="M99.21 386.88C94.88 386.03 90.67 388.86 89.82 393.19L68.75 500.72C66.61 510.85 82.56 514.05 84.45 503.8L105.52
      396.27C106.37 391.94 103.54 387.73 99.21 386.88Z"
      fill="currentColor"
    />
  </svg>
</template>
